var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"px-12 py-8 my-2 round-corner justify-center align-center",attrs:{"color":"blue","dark":"","x-large":"","block":""},on:{"click":_vm.cloneCollection}},[_vm._v("\n  Fazer backup dos vídeos\n")])}
var staticRenderFns = []

export { render, staticRenderFns }